import Vue from 'vue';
import Component from 'vue-class-component';
import SidebarComponent from '@/components/sidebar/sidebar.component.vue';
import HeaderComponent from '@/components/header/header.component.vue';
import LoaderComponent from '@/components/loader/loader.component.vue';
import ModalPermissionsComponent from '@/components/modal-permissions/modal-permissions.component.vue';
import ModalLoginComponent from '@/components/modal-login/modal-login.component.vue';
// External components
import Datepicker from 'vuejs-datepicker';
// Services
import SectionService from '@/core/services/section.service.ts';
import SidebarService from '@/core/services/sidebar.service.ts';

@Component({
  components: {
    SidebarComponent,
    HeaderComponent,
    LoaderComponent,
    ModalPermissionsComponent,
    ModalLoginComponent,
    Datepicker
  }
})
export default class SectionInactiveComponent extends Vue {

  sectionService: any = new SectionService();
  sidebarService: any = new SidebarService();
  isLoading: boolean = false;
  modal: boolean = false;
  logInModal: boolean = false;
  showModal: boolean = false;
  deleteIcon: boolean = false;
  nextPositionDisabled: boolean = false;
  previousPositionDisabled: boolean = true;
  pagination: boolean = true;
  sectionToActivar: any;
  sectionList: any = [];
  filterSectionList: any = [];
  searchFlag: any = [];
  search: string = "";
  name: string = "";
  searchByDate: any = "";
  deletedAt: string = "";
  filterConcatDate: string = "";
  pageOffset: number = 0;
  itemsPerPage: number = 50;
  totalPages: number;
  currentPage: number = 1;
  nextPage: number = 2;
  totalOfSection: number = 0;
  itemsOfFrom: number = 0;
  itemsOfTo: number = 0;

  mounted (){
    const _ = this;
    _.getInactive(_.pageOffset, _.itemsPerPage);
    _.filterDate();
  }

  filterByDate(){
    const _ = this;
    _.deleteIcon = true;
    let day = _.searchByDate.getDate() < 10 ? '0' + _.searchByDate.getDate() : _.searchByDate.getDate();
    let month = _.searchByDate.getMonth() < 10 ? '0' + (_.searchByDate.getMonth() + 1) : _.searchByDate.getMonth() + 1;
    let year = _.searchByDate.getFullYear();
    _.filterConcatDate = `${year}-${month}-${day}`;
    _.filterSectionList = _.sectionList.filter((role) => {
      let parseDate: any = role.deletedAt.split('T');
      parseDate = parseDate[0];
      return _.filterConcatDate == parseDate;
    })
  }

  deleteDate(){
    const _ = this;
    _.filterConcatDate = '';
    _.deleteIcon = false;
    if(_.filterConcatDate == ''){
      _.searchByDate = '';
      _.filterSectionList = _.sectionList;
      return;
    }
  }

  filterDate(date: any = ''){
    const _ = this;
    date = date.split("T");
    date = date[0];
    return date;
  }

  closeSidebar(){
    const _ = this;
    _.sidebarService.close();
  }

  openModal(id){
    const _ = this;
    _.sectionToActivar = id;
    _.modal = true;
  }

  getInactive(pageOffset = 0, itemsPerPage = 50){
    const _ = this;
    console.log(pageOffset, itemsPerPage);
    _.isLoading = true;
    _.sectionService.getInactive(pageOffset, itemsPerPage).then((data: any) => {
      console.log(data);
      _.sectionList = data['data'].sections;
      _.filterSectionList = data['data'].sections;
      console.log(data);
      _.totalOfSection = data['data'].total;
      _.totalPages = Math.ceil(_.totalOfSection / itemsPerPage);
      console.log(_.totalPages, 'totalPages');
      if(_.totalPages <= 1){
        _.pagination = false;
      }
      if(pageOffset == 0){
        _.itemsOfFrom = 1;
        _.itemsOfTo = _.sectionList.length;
        _.previousPositionDisabled = true;
        console.log(_.itemsOfTo, '555');
      }
      if(pageOffset != 0){
        _.previousPositionDisabled = false;
      }
      if (pageOffset == _.totalPages - 1){
        _.itemsOfTo = _.totalOfSection;
      }
      setTimeout(() => {
        _.isLoading = false;
      }, 2000)
    })
    .catch((err: any) => {
      if(err.response.data.message.includes('Invalid or inexistent user')){
        localStorage.removeItem('tk_auth');
        _.logInModal = true;
      }
      setTimeout(() => {
        _.isLoading = false;
      }, 2000)
    })
  }

  active_section(reactivate){
    const _ = this;
    _.isLoading = true;
    _.sectionService.active_section(_.sectionToActivar, reactivate).then((data: any) => {
      _.getInactive();
      setTimeout(() => {
        _.isLoading = false;
      }, 1500)
    })
    .catch((err: any) => {
      setTimeout(() => {
        _.isLoading = false;
      }, 2000)
    })
  }

  nextPageAction(){
    const _ = this;
    _.itemsOfTo = (_.itemsOfTo + _.sectionList.length);
    console.log(_.itemsOfTo, 'incremento 1')
    _.itemsOfFrom = (_.itemsOfFrom + _.sectionList.length);
    console.log(_.itemsOfFrom, 'incremento 2')
    _.pageOffset++;
    _.currentPage++;
    _.nextPage++;
    _.getInactive(_.pageOffset);

    if(_.totalPages == _.currentPage){
      _.nextPositionDisabled = true;
      console.log(_.nextPositionDisabled, '98898')
      return
    }
  }

  previousPageAction(){
    const _ = this;
    if(_.currentPage == 1){
      return
    }
    _.itemsOfTo = _.itemsOfTo - _.sectionList.length;
    _.itemsOfFrom = _.itemsOfFrom - _.sectionList.length;
    _.pageOffset--;
    _.currentPage--;
    _.nextPage--;
    _.getInactive(_.pageOffset);

    if(_.totalPages != _.currentPage){
      _.nextPositionDisabled = false;
      console.log(_.nextPositionDisabled, 'false')
      return
    }
  }
}
